/* eslint-disable @nx/enforce-module-boundaries */
import { Divider, HStack, Heading, SeeMore, Stack, Text } from '@mybridge/ui';
import { forwardRef, useContext } from 'react';
import { PublicProfileContext } from '../context';
import _ from 'lodash';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const MyProfileIntroduction = forwardRef(({ ...props }, ref) => {
  const { publicProfile } = useContext(PublicProfileContext);
  const { profile_intro: intro } =
    publicProfile ?? {};
  const { t } = useTranslator();
  
  if (!intro) return <></>;

  return (
    <>
      <Stack>
        <HStack alignItems="flex-start">
          <Stack flex={1}>
            <Heading fontSize="20px" color="brandPrimary.500" fontWeight="400">
              {t('publicProfile.intro') || "Intro"}
            </Heading>
          </Stack>
        </HStack>
        <Stack pl={1}>
          {intro?.length ? (
            <SeeMore
              maxHeight="90px"
              html={intro}
              className="event-description"
              maxLength={300}
            />
          ) : (
            <Text>
              {t('publicProfile.writeAboutExperience') || "You can write about your years of experience, skills, achievements or previous job experiences."}
            </Text>
          )}
        </Stack>
      </Stack>
    </>
  );
});

